import { AppThunk } from '../../../../../../store/types';
import { PhraseDetailsTabsEditorPopupActions } from '../../../../../../store/phrase-details-tabs-editor-popup/actions';
import { PhraseDetailsTabsEditorPopupSelectors } from '../../../../../../store/phrase-details-tabs-editor-popup/selectors';
import { PhraseDetailsTabEffects } from '../../../../../../effects/phraseDetailsTabEffects';
import { EPhraseDetailsTabsEditorViewMode } from '../../../../../../store/phrase-details-tabs-editor-popup/types';
import {
  IPhraseDetailsPromptValidatorResult,
  PhraseDetailsPromptValidator
} from '../../../../../../effects/phrase-details/phraseDetailsPromptValidator';
import { PhraseDetailsSelectors } from '../../../../../../store/phrase-details/selectors';
import { PhraseDetailsCustomPromptTestService } from '../../../../../../effects/phrase-details/phraseDetailsService/phrase-details-custom-prompt-test-service';
import { EventsRouter } from '../../../../../../../common/events/eventsRouter';
import { Events } from '../../../../../../../common/events/types';
import { PhraseContextEditorSelectors } from '../../../../../../store/phrase-context-editor/selectors';
import { batch } from 'react-redux';
import { PhraseDetailsActions } from '../../../../../../store/phrase-details/actions';
import { EPhraseDetailsTabType } from '../../../../../../store/models/types';

export class PhraseDetailsTabLibPromptFormEvents {

  public static onShow(): AppThunk {
    return async(
      dispatch,
      getState
    ) => {
      dispatch(PhraseDetailsTabsEditorPopupActions.setLastSaveTabId(0));
    }
  }

  public static onSave(title: string, prompt: string, description: string): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      const state = getState();
      EventsRouter.trackEvent(Events.SAVE_TO_MY_PROMPTS_BUTTON_CLICKED);
      dispatch(PhraseDetailsTabsEditorPopupActions.setProcessing(true));
      const promptLib = PhraseDetailsTabsEditorPopupSelectors.getOpenPromptLib(state)
      const savedTab = await PhraseDetailsTabEffects.saveCustomPrompt(0, title, prompt, description);
      dispatch(PhraseDetailsTabsEditorPopupActions.setProcessing(false));
    //  dispatch(PhraseDetailsTabsEditorPopupActions.setViewMode(EPhraseDetailsTabsEditorViewMode.MAIN));

      dispatch(PhraseDetailsTabsEditorPopupActions.setEditTabId(savedTab.id));
      dispatch(PhraseDetailsTabsEditorPopupActions.setLastSaveTabId(savedTab.id));
      dispatch(PhraseDetailsTabsEditorPopupActions.setViewMode(EPhraseDetailsTabsEditorViewMode.CREATE));
      dispatch(PhraseDetailsTabsEditorPopupActions.setPromptTestResult(''));

      const promptsChat = PhraseDetailsSelectors.getPromptsChat(getState()) || [];
      const index = promptsChat.findIndex(i =>
        i.type !== EPhraseDetailsTabType.CUSTOM_PROMPT &&
        i.id === promptLib?.id
      );
      if (index > -1) { // lib prompt used, replace it with saved
        const chat = [...promptsChat];
        chat[index] = {
          ...promptsChat[index],
          id: savedTab.relationId,
          type: EPhraseDetailsTabType.CUSTOM_PROMPT,
        }
        dispatch(PhraseDetailsActions.setPromptsChat(chat));
      }
    }
  }

  public static onValidate(prompt: string): AppThunk {
    return (
      dispatch,
      getState
    ): IPhraseDetailsPromptValidatorResult => {
      return PhraseDetailsPromptValidator.validate(prompt);
    }
  }

  public static onPromptChange(prompt: string): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      const state = getState();
      let phrasePreview = PhraseContextEditorSelectors.getPhraseText(state);
      let text = phrasePreview && phrasePreview.id < 0 && phrasePreview?.highlighted || '';
      let context = PhraseContextEditorSelectors.getPhraseContext(state)?.fullPhrase || PhraseDetailsSelectors.getContext(state) || PhraseDetailsSelectors.getCaptionLineContext(state) || '';
      let fromLang = PhraseDetailsSelectors.getFromLang(state);
      let toLang = PhraseDetailsSelectors.getToLang(state);

      if (!text) { // no phrase selected
        const firstCaptionAsPhrase = PhraseDetailsTabsEditorPopupSelectors.getFirstCaptionAsPhrase(state);
        if (firstCaptionAsPhrase && firstCaptionAsPhrase.text) {
          text = firstCaptionAsPhrase.text;
          context = firstCaptionAsPhrase.context || '';
          fromLang = firstCaptionAsPhrase.fromLang;
          toLang = firstCaptionAsPhrase.toLang;
        }
      }

      const service = new PhraseDetailsCustomPromptTestService(text, context, fromLang?.code || '', toLang?.code || '', prompt);
      let test = await service.getPreparedPrompt(prompt, false);

      batch(() => {
        dispatch(PhraseDetailsTabsEditorPopupActions.setPromptTestPrompt(test));
        dispatch(PhraseDetailsTabsEditorPopupActions.setPromptTestRawPrompt(prompt));
      })
    }
  }
}